import { atom } from "recoil";

export const importModalOpenState = atom<boolean>({
  key: "ImportModalOpenState",
  default: false,
});
